import isDocumentContent from "./isDocumentContent";
import isDocumentMapDataGeometry from "./isDocumentMapDataGeometry";
import isDocumentMapDataPoint from "./isDocumentMapDataPoint";
import isEdgeSource from "./isEdgeSource";
import isNodeSource from "./isNodeSource";
export default (item) => (isNodeSource(item) && item.NodeId) ||
    (isEdgeSource(item) && item.EdgeId) ||
    (isDocumentMapDataPoint(item) && item.Id) ||
    (isDocumentMapDataGeometry(item) && item.Id) ||
    (isDocumentContent(item) && item.Id) ||
    undefined;
